
export default class DisplaySchema {
  constructor (initProps = {}) {
    this.displayName = ''
    this.displayOrder = 0
    this.displayType = null // from list of display types
    this.displayTypeProps = {} // will be of type: displayType: props
    this.displayViewable = true
    this.displayEditable = true
    this.markupAttributes = {}
    this.invalidMessage = ''
    this.properties = {} // used only for displayType: COLLECTION
    this.itemSchema = null // used only for displayType: LIST

    for (let key in this) {
      if (initProps.hasOwnProperty(key)) {
        this[key] = initProps[key]
      }
    }
  }

}
